// Add your custom JS here.

if (jQuery(window).width() < 767) {
    jQuery('.dropdown-toggle').each(function(){
        jQuery(this).attr('data-bs-toggle','dropdown'); 
    })
}

document.addEventListener('DOMContentLoaded', function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

jQuery(document).ready(function() {

    /*
    const defaultNavLink = jQuery(".navbar-fy .navbar-nav .nav-item:first-child .nav-link"); // Default to the first nav-link
    const savedNavLink = localStorage.getItem("activeNavLink");
    var savedNavFolded = localStorage.getItem("navFolded"); // Get the saved navigation state

    if (savedNavFolded == null) {
        // if new user show the navigation
        savedNavFolded = 'false';
        saveFolded("false");
    }

    // Restore the saved menu state
    if (savedNavFolded == 'false') {
        // alert('navFolded is ' + savedNavFolded);

        const activeLink = jQuery(`.navbar-fy .navbar-nav .nav-link[href="${savedNavLink}"]`);

        if (activeLink.length) {
            activateNavLink(activeLink);
        } else {
            activateNavLink(defaultNavLink); // If saved link doesn't exist, use the default
        }

        // turn all unfold checkboxes in the navigation off
        jQuery('.form-check-input-unfold').prop('checked', true);
    } else {
        // is true
        jQuery('.form-check-input-unfold').prop('checked', false);
    }

    // Handle click events for all nav-links
    jQuery(".navbar-fy .navbar-nav .nav-link").on("click", function (e) {
        // Activate the clicked link and save it
        localStorage.setItem("activeNavLink", jQuery(this).attr("href"));
    });

    // Function to activate a given nav-link
    function activateNavLink(link) {
        link.addClass("show"); // Add active classes
        
        if (link.hasClass("dropdown-toggle")) {
            link.next(".dropdown-menu").addClass("show"); // Show dropdown for dropdown links
            jQuery('body').addClass('padding-top-400');
        }
    }

    function foldNavigation(){
        jQuery('body').removeClass('padding-top-400').addClass('padding-top-100');
    }

    function unfoldNavigation(){
        jQuery('a.nav-link').removeClass('show');
        jQuery('.dropdown-menu').removeClass('show');

        // Check if the body doesn't already have the padding class for 400px
        if (!jQuery('body').hasClass('padding-top-400')) {
            jQuery('body').removeClass('padding-top-100').addClass('padding-top-400');
        }
    }

    function saveFolded(value = 'false') {
        localStorage.setItem("navFolded", value); // Save folded state
    }
    jQuery('.navbar-fy .dropdown').on('show.bs.dropdown', function () {
        // unfoldNavigation();
        // saveFolded("false");

        // Add the rotated-icon class to the current dropdown toggle
        jQuery('.dropdown-toggle').removeClass('rotated-icon');
        jQuery(this).find('.dropdown-toggle').addClass('rotated-icon');
    });

    // When a dropdown menu is hidden
    jQuery('.navbar-fy .dropdown').on('hide.bs.dropdown', function () {
        // foldNavigation();
        // saveFolded("true"); // Save folded state

        jQuery('.dropdown-toggle').removeClass('rotated-icon');
    });     
    */





    jQuery('.form-check-input').change(function() {
        if (jQuery(this).is(':checked')) {
            // Call function when checkbox is checked
            saveFolded("false");
        } else {
            // Call function when checkbox is unchecked
            saveFolded("true");
        }
    });


    /*
    jQuery('.form-join-email').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/join/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                }

                if (data.showpasswordfield) {
                    // user already has an account, let him login
                    jQuery('#join-password-wrapper').show();
                    jQuery('#join-password').focus();

                } else {
                    // user is NOT YET having an account, sign him up
                    if (data.mailresult && data.join_uuid) {
                        // mail was sent - forward user to code confirmation page
                        window.location.href = '/join/?action=confirm-show&uuid='+data.join_uuid;
                    } else {
                        alert('The email you entered cannot be used. Try another one.');
                    }
                } 


                // jQuery('#join-form-body').hide();
                // jQuery('#join-form-message').show();

            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });
    */

    /*
    jQuery('.form-join-confirm').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/join-confirm/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {

            if (data.success) {

                console.log(data);

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                }
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });
    */

    jQuery('.call_event_showhide').on('click', function(event) {
        event.preventDefault();

        var post_id = jQuery(this).data('id');
        var title = jQuery(this).data('title');

        if (confirm("Do you want to report and hide the unverified event '"+title+"'?")){
            jQuery('#event-'+post_id).fadeOut(1000);

            // const formData = new FormData(this);
            var formData = new FormData();
            formData.append('post_id', post_id);

            // Submit form data via fetch
            fetch('/api/v1/showhide-event/', 
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        // 'X-WP-Nonce': nonce // Send the nonce in the request header
                    }
                })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // OK
                    // alert('Done!');
                } else {
                    alert('Error: ' + data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        };
    });


    jQuery('[data-required="true"]').each(function() {
        const input = this;

        // Only attach if Tagify is initialized on this field
        if (input.tagify) {
            input.tagify.on('add', function() {
                const wrapper = jQuery(input).siblings('tags');
                wrapper.removeClass('is-invalid');
            });

            input.tagify.on('remove', function(e) {
                // If all tags removed and it's required, show error again
                const wrapper = jQuery(input).siblings('tags');
                if (jQuery(input).val().trim() === '') {
                    wrapper.addClass('is-invalid');
                }
            });
        }
    });

    function validateRequiredFields(form) {
        let isValid = true;
        let firstInvalidField = null;

        form.find('[data-required="true"]').each(function() {
            const field = jQuery(this);
            const value = field.val().trim();
            const tagifyWrapper = field.siblings('tags');

            const target = tagifyWrapper.length ? tagifyWrapper : field;

            if (value === '') {
                target.addClass('is-invalid');

                if (!firstInvalidField) {
                    firstInvalidField = target;
                }

                isValid = false;
            } else {
                target.removeClass('is-invalid');
            }
        });

        return isValid;
    }

    function bindRealtimeValidation(form) {
        // Regular inputs (text, select, textarea, etc.)
        form.find('[data-required="true"]').on('input change', function() {
            const field = jQuery(this);
            const value = field.val().trim();
            const tagifyWrapper = field.siblings('tags');
            const target = tagifyWrapper.length ? tagifyWrapper : field;

            if (value === '') {
                target.addClass('is-invalid');
            } else {
                target.removeClass('is-invalid');
            }
        });

        // Tagify-enhanced inputs
        form.find('[data-required="true"]').each(function() {
            const input = this;
            if (input.tagify && !input._validationBound) {
                input._validationBound = true;

                input.tagify.on('add remove', function() {
                    const wrapper = jQuery(input).siblings('tags');
                    if (jQuery(input).val().trim() === '') {
                        wrapper.addClass('is-invalid');
                    } else {
                        wrapper.removeClass('is-invalid');
                    }
                });
            }
        });
    }

    const form = jQuery('.call_yard_form');
    validateRequiredFields(form);        // Validate on load
    bindRealtimeValidation(form);        // Bind change handlers

    jQuery(document).on('submit', '.call_yard_form', function(event) {
        event.preventDefault();

        const form = jQuery(this);
        const formEntity = form.data('entity'); // Get the entity type

        const formNonce = jQuery('#yard-nonce').html();
        const formGuestnonce = jQuery('#yard-guestnonce').html();

        const isValid = validateRequiredFields(form);

        if (!isValid) {
            const firstInvalid = form.find('.is-invalid').first();
            if (firstInvalid.length) {
                jQuery('html, body').animate({
                    scrollTop: firstInvalid.offset().top - 100
                }, 400);
                firstInvalid.focus();
            }
            return;
        }

        let formData = form.serialize(); // Serialize form data

        // Add formEntity to the serialized data
        formData += `&entity=${encodeURIComponent(formEntity)}&guestnonce=${encodeURIComponent(formGuestnonce)}`;

        // jQuery('.call_yard_form').find('input, textarea, select, button').prop('disabled', true);
        jQuery('#yard-loader-modal').show();
 
        // Submit form data via fetch
        fetch('/api/v1/set-yardform/', 
            {
                method: 'POST',
                // credentials: 'same-origin',
                credentials: 'include', 
                body: formData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'X-WP-Nonce': formNonce
                }
            })
        .then(response => response.json())
        .then(data => {

            jQuery('.call_yard_form').find('input, textarea, select, button').prop('disabled', false);

            if (data.success) {

                if (data.javascript) {
                    try {
                        // Execute the JavaScript code in data.javascript
                        eval(data.javascript);
                    } catch (e) {
                        console.error('Error executing JavaScript:', e);
                    }
                }

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                } else {
                    // console.log('Form was saved.');
                    jQuery('#yard-loader-modal').hide();
                }

                if (formEntity == 'join-fields') {
                    // hide all steps
                    jQuery('.join-step').hide();

                    // fill step with current html, if existing
                    if (data.html != '') {
                        jQuery('#'+data.showstep).html(data.html);
                    }
                    
                    // show current step
                    jQuery('#'+data.showstep).show();
                }

                if (formEntity == 'eventmanage') {
                    /* now in API class
                    jQuery('#yard-eventmanage-body').hide();
                    jQuery('.modal-footer-form-button .btn-primary').hide();
                    jQuery('#yard-eventmanage-message').show();
                    */
                }
                
            } else {
                alert('Error: ' + data.message);
                jQuery('#yard-loader-modal').hide();
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });

    jQuery(document).on('click', '.call_yard_link', function(event) {
        event.preventDefault();

        const link = jQuery(this);
        const linkEntity = link.data('entity'); 
        const linkId = link.data('id'); 
        const linkAction = link.data('action'); 

        const linkNonce = jQuery('#yard-nonce').html();
        const linkGuestNonce = jQuery('#yard-guestnonce').html();

        let linkData = link.serialize();

        // Add formEntity to the serialized data
        linkData += `&entity=${encodeURIComponent(linkEntity)}`;

        if (linkId != '') {
            linkData += `&id=${encodeURIComponent(linkId)}`;
        }
 
        if (linkAction != '') {
            linkData += `&action=${encodeURIComponent(linkAction)}`;
        }

        if (linkGuestNonce != '') {
            linkData += `&guestnonce=${encodeURIComponent(linkGuestNonce)}`;
        }

        // Submit form data via fetch
        fetch('/api/v1/set-yardform/', 
            {
                method: 'POST',
                // credentials: 'same-origin',
                credentials: 'include', 
                body: linkData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'X-WP-Nonce': linkNonce
                }
            })
        .then(response => response.json())
        .then(data => {

            if (data.success) {
                if (data.javascript) {
                    try {
                        // Execute the JavaScript code in data.javascript
                        eval(data.javascript);
                    } catch (e) {
                        console.error('Error executing JavaScript:', e);
                    }
                }

                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                } else {
                    // console.log('Form was saved.');
                    jQuery('#yard-loader-modal').hide();
                }
                
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });


    jQuery(document).on('click', '.call_changemodaldisplay', function(event) {
        var mode = jQuery(this).data('display');
    
        if (mode == "show-expert") {
            // show expert
            jQuery('.modaldisplay_default_basic').removeClass('modaldisplay_hide');
            jQuery('#changemodaldisplay-expert').show();
            jQuery('#changemodaldisplay-basic').hide();
        } else {
            // show basic
            jQuery('.modaldisplay_default_basic').addClass('modaldisplay_hide');
            jQuery('#changemodaldisplay-expert').hide();
            jQuery('#changemodaldisplay-basic').show();
        }
    });


    jQuery(document).on('click', '.call_modal', function(event) {
        event.preventDefault();

        console.log(' .call_modal in custom-javascript.js ');

        var id = jQuery(this).data('id');
        var entity = jQuery(this).data('entity');

        const nonce = jQuery('#yard-nonce').html();
        const guestnonce = jQuery('#yard-guestnonce').html();

        var display = jQuery(this).data('display'); // "expert" or "basic", if defined
        var showcity = jQuery(this).data('showcity'); // "true" or "false", if defined

        var fetchurl = '/api/v1/get-yardmodal/?id='+id+'&entity='+entity;

        if (display) {
            fetchurl += '&display='+display;
        }

        if (showcity) {
            fetchurl += '&showcity='+showcity;
        }

        if (guestnonce) {
            guestnonce += '&guestnonce='+guestnonce;
        }

        // Submit form data via fetch
        fetch(fetchurl, 
            {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'X-WP-Nonce': nonce
                }
            })
        .then(response => response.json())
        .then(data => {

            if (data.success) {
                var modalId = '#yard-modal-' + entity + '-' + id;

                jQuery('body').append(data.modal);
                jQuery(modalId).modal('show');

                jQuery(document).on('shown.bs.modal', function () {
                    var modals = jQuery('.modal.show');
                    var backdrops = jQuery('.modal-backdrop');
                
                    modals.each(function (index) {
                        var $modal = jQuery(this);
                        var modalZIndex = 1050 + (index * 20); // Unique zIndex for each modal
                        $modal.css('z-index', modalZIndex);
                
                        // Ensure each backdrop is above the previous modal and backdrop
                        if (backdrops[index]) {
                            jQuery(backdrops[index]).css('z-index', modalZIndex - 5); // Backdrop is just below the next modal
                        }
                    });
                });
                
                // Attach an event listener to remove the modal from DOM when it's closed
                jQuery(modalId).on('hidden.bs.modal', function() {
                    jQuery(this).remove();
                });                
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });

    });


    jQuery('.form-save-card-feedback').on('submit', function(event) {
        event.preventDefault();

        // Collect form data
        const formData = new FormData(this);

        // Get the nonce value from the form
        const nonce = formData.get('custom_form_nonce');

        // Submit form data via fetch
        fetch('/api/v1/save-card-feedback/', 
            {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    // 'X-WP-Nonce': nonce // Send the nonce in the request header
                }
            })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                jQuery(".form-add-event").trigger("reset");
                jQuery("#form-save-card").hide();
                jQuery('#message-save-card').show();

                /*
                setTimeout(function() {
                    jQuery('#add-message').hide();
                }, 15000);
                */
            } else {
                alert('Error: ' + data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });

    document.querySelectorAll('.dropdown-filter').forEach(dropdown => {
        const button = dropdown.querySelector('.dropdown-toggle');
        const items = dropdown.querySelectorAll('.dropdown-item');
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
    
        items.forEach(item => {
          item.addEventListener('click', function(event) {
            event.preventDefault();
    
            // Remove the active class from all dropdown items in this dropdown
            items.forEach(i => i.classList.remove('active'));
    
            // Add the active class to the clicked item
            this.classList.add('active');
    
            // Get selected value and text (icon + text)
            const selectedValue = this.getAttribute('data-value');
            const selectedText = this.innerHTML;

            // Update the button to show the selected item (with icon)
            button.innerHTML = selectedText;
    
            // Update the hidden input value
            hiddenInput.value = selectedValue;
          });
        });
    });
    

    // Scrolling offset for #samepagelinks
    // adjust this to your sticky nav height
    var offset = jQuery('.navbar').outerHeight() || 80;
    // On page load with hash
    if (window.location.hash) {
        var target = jQuery(window.location.hash);
        if (target.length) {
            jQuery('html, body').animate({
                scrollTop: target.offset().top - offset
            }, 500);
        }
    }
    // On click of anchor links
    jQuery('a[href*="#"]').on('click', function(e) {
        var pathname = location.pathname.replace(/^\//, '');
        var thisPath = this.pathname.replace(/^\//, '');

        if (pathname === thisPath && location.hostname === this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                e.preventDefault();
                jQuery('html, body').animate({
                    scrollTop: target.offset().top - offset
                }, 500);
            }
        }
    });



});






/* /js/child-theme.js */
/* Popper support for popovers */
(function () {
  "use strict";

  jQuery(function () {
    // --- Header split dropdown: explicit, manual toggle ----------------------
    var toggle = document.getElementById("accountMenuToggle");
    if (toggle && window.bootstrap && typeof window.bootstrap.Dropdown === "function") {
      // Ensure official attribute (prevents reparenting in fixed headers)
      if (!toggle.hasAttribute("data-bs-display")) {
        toggle.setAttribute("data-bs-display", "static");
      }

      // Create (or re-create) an instance
      var dd;
      try {
        var prev = window.bootstrap.Dropdown.getInstance(toggle);
        if (prev) prev.dispose();
        dd = new window.bootstrap.Dropdown(toggle);
      } catch (_) {}

      // Manually toggle on click
      toggle.addEventListener("click", function () {
        try {
          if (dd && typeof dd.toggle === "function") {
            dd.toggle();
          }
        } catch (_) {}
      });

      // Close on Escape
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && dd && typeof dd.hide === "function") {
          try { dd.hide(); } catch (_) {}
        }
      });
    }

    // --- Init any other dropdowns (idempotent) -----------------------
    if (window.bootstrap && typeof window.bootstrap.Dropdown === "function") {
      document.querySelectorAll("[data-bs-toggle='dropdown']").forEach(function (el) {
        if (el === toggle) return;
        try {
          if (!window.bootstrap.Dropdown.getInstance(el)) {
            new window.bootstrap.Dropdown(el);
          }
        } catch (_) {}
      });
    }

    // --- Popovers ----------------------------------------------------
    if (window.bootstrap && typeof window.bootstrap.Popover === "function") {
      document.querySelectorAll("[data-bs-toggle='popover']").forEach(function (el) {
        try {
          var p = window.bootstrap.Popover.getInstance(el);
          if (p) p.dispose();
          new window.bootstrap.Popover(el, { trigger: "hover focus", container: "body", html: true });
        } catch (_) {}
      });
    }
  });


// Fix double-toggle AND keep hamburger animation/state in sync
document.addEventListener('DOMContentLoaded', function () {
  var target  = document.getElementById('navbar-mobile');
  var toggler = document.querySelector('[data-bs-toggle="collapse"][data-bs-target="#navbar-mobile"]');
  if (!target || !window.bootstrap || !bootstrap.Collapse || !toggler) return;

  // One Bootstrap instance; do NOT auto open on init
  var inst = bootstrap.Collapse.getOrCreateInstance(target, { toggle: false });

  // Clone to strip any 3rd-party listeners
  var clean = toggler.cloneNode(true);

  // Prevent Bootstrap data-API from (re)binding and double-toggling
  clean.removeAttribute('data-bs-toggle');
  clean.removeAttribute('data-bs-target');
  clean.setAttribute('aria-controls', 'navbar-mobile');

  // Put the clean button back
  toggler.parentNode.replaceChild(clean, toggler);

  // Helpers for icon animation classes
  var iconWrap = clean.querySelector('.hamburger-toggle');
  var icon     = clean.querySelector('.hamburger');

  function setButtonState(open) {
    if (open) {
      clean.classList.remove('collapsed');
      clean.setAttribute('aria-expanded', 'true');
      if (iconWrap) iconWrap.classList.add('is-active'); // adjust if your CSS uses "active" or "open"
      if (icon)     icon.classList.add('is-active');
    } else {
      clean.classList.add('collapsed');
      clean.setAttribute('aria-expanded', 'false');
      if (iconWrap) iconWrap.classList.remove('is-active');
      if (icon)     icon.classList.remove('is-active');
    }
  }

  // Initial state
  setButtonState(target.classList.contains('show'));

  // Our single, first-in-line click handler (prevents double-toggle)
  clean.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    inst.toggle();
  }, true);

  // Mirror collapse lifecycle back to the button so the CSS animation runs
  target.addEventListener('show.bs.collapse',   function(){ setButtonState(true);  }, true);
  target.addEventListener('shown.bs.collapse',  function(){ setButtonState(true);  }, true);
  target.addEventListener('hide.bs.collapse',   function(){ setButtonState(false); }, true);
  target.addEventListener('hidden.bs.collapse', function(){ setButtonState(false); }, true);
});





})();
